/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".countdown[_ngcontent-%COMP%] {\r\n    display: none !important;\r\n}"];
export { styles as styles };
